"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCard = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCard = styled_components_1.default.div.withConfig({ displayName: "StyledCard", componentId: "sc-4578li" }) `
  border-radius: ${(props) => props.theme.radii.primary};
  background-color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x3};

  ${(props) => (0, ui_1.mq)({
    boxShadow: props.theme.shadows.tertiary,
    width: ['auto', null, '261px'],
})}
`;
